import { FETCH_HOSPITAL_FAIL, FETCH_HOSPITAL_REQUEST, FETCH_HOSPITAL_SUCCESS } from "../../ActionType/HospitalType/HospitalType";

const initalState = {
    hospitals: [],
    loading: false,
    error: null,
    total: 0,

};

export const getHospitalReducer = (
  state = initalState,
  action
) => {
  switch (action.type) {
    
    case FETCH_HOSPITAL_REQUEST:
      // console.log(action)
      return {
        loading: true,
        hospitals: action.payload,
      };
    case FETCH_HOSPITAL_SUCCESS:
      // console.log(action)
      return {
        loading: false,
        hospitals: action.payload.data,
        total: action.payload.total,
        error: "",
      };
    case FETCH_HOSPITAL_FAIL:
      // console.log(action)
      return {
        loading: false,
        hospitals: action.payload,
        error: "",
      };
    default:
      return state;
  }
};